import promoCash from './promo-cash.webp';
import promoCoins from './promo-coins.webp';
import promoWheel from './promo-wheel.webp';
import lockedPromo from './locked-promo.webp';
import noPromo from './no-promo.webp';
import shield from './shield.webp';
import unchecked from './unchecked.webp';
import checked from './checked.webp';
import badge from './badge.webp';
import info from './info.webp';

import payments from './payments';

export default {
  ...payments,
  promoCash,
  promoCoins,
  promoWheel,
  lockedPromo,
  noPromo,
  shield,
  unchecked,
  checked,
  badge,
  info,
};
